import React from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter, RouteComponentProps } from 'react-router';
import queryString from 'query-string-for-all';
import { AppContext } from '@prisjakt/ui-app-context';
import { AppState } from '../../reducers';
import { promptToast as promptToastAction } from '../../components/toast-container/actions';
import { newsletterSubscribeVerified as newsletterSubscribeVerifiedAction } from './actions';

type NewsletterVerificationProps = {
  promptToast: typeof promptToastAction;
  newsletterSubscribeVerified: typeof newsletterSubscribeVerifiedAction;
} & RouteComponentProps;
const NewsletterVerification = (props: NewsletterVerificationProps) => {
  const { t } = React.useContext(AppContext);
  const { promptToast, location, newsletterSubscribeVerified } = props;
  React.useEffect(() => {
    const { email, hash } = queryString.parse(location.search);
    fetch(`/_internal/newsletter/confirm-subscription`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, hash }),
    })
      .then(res => res.json())
      .then(({ success }) => {
        if (success) {
          newsletterSubscribeVerified(String(email));
          promptToast(
            'success',
            t('footer', 'newsletter.subscription-confirmed')
          );
        } else {
          promptToast('error', t('errors', 'internal.unknown'));
        }
      })
      .catch(r => {
        promptToast('error', t('errors', 'internal.unknown'));
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <Redirect to="/" />;
};

export default connect(
  (state: AppState) => {},
  {
    promptToast: promptToastAction,
    newsletterSubscribeVerified: newsletterSubscribeVerifiedAction,
  }
)(withRouter(NewsletterVerification));
